let block_tree = {}; // just get only block save in this not to again make tree
const treeify = (arr, pid) => {
  const tree = [];
  const lookup = {};
  // Initialize lookup table with each array item's id as key and
  // its children initialized to an empty array
  arr.forEach((o) => {
    lookup[o.id] = o;
    lookup[o.id].children = [];
  });
  arr.forEach((o) => {
    // If the item has a parent we do following:
    // 1. access it in constant time now that we have a lookup table
    // 2. since children is preconfigured, we simply push the item
    if (o.parent_id !== null) {
      lookup[o.parent_id].children.push(o);
    } else {
      // no o.parent so this is a "root at the top level of our tree
      tree.push(o);
    }
  });
  return [tree, lookup];
};

const re_organize_data = (data) => {
  const org = [];
  data.forEach((element) => {
    const attributes = {
      designation: element["employee__designation"],
      department: element["employee__department"],
      group: element["employee__group"],
      email: element["employee__email"],
      code: element["employee__emp_code"],
    };
    const others = {
      contact_num: element["employee__contact_num"],
      employee_id: element["employee_id"],
      //   id: element["id"],
      //   parent_id: element["parent_id"],
      parent_name: element["parent_id__employee__username"],
    };
    const merge_data = {
      employee_id: element["employee_id"],
      name: element["employee__username"],
      id: element["id"],
      parent_id: element["parent_id"],
      attributes: attributes,
      others: others,
    };
    org.push(merge_data);
  });
  return org;
};

// for testing purpose remove after testing

export const test = (data) => {
  const lookup = {};
  data.forEach((element) => {
    lookup[element["others"].id] = element["others"];
  });
};
export const org_data_tree = (data) => {
  const tree = treeify(re_organize_data(data));
  return tree[0];
};

export const org_block = (data, id) => {
  const tree = treeify(re_organize_data(data))[1];
  const result = Object.values(tree).find((obj) => obj.employee_id === id);
  block_tree = result;
  // console.log("tree", tree)
  return result;
};

export const emails_by_position_wise = (designation_type) => {
  // console.log(Object.keys(block_tree).length);
  if (Object.keys(block_tree).length > 0) {
    const result = {};
    const stack = [block_tree];
    while (stack.length > 0) {
      const curr = stack.pop();
      const employee_id = curr.others.employee_id;
      const designation = curr.attributes.designation;

      if (employee_id && designation === designation_type) {
        if (!result[designation]) {
          result[designation] = [];
        }
        result[designation].push(employee_id);
      }

      if (curr.children) {
        stack.push(...curr.children);
      }
    }
    return result;
  } else return null;
};
export const all_employees_in_block = () => {
  if (Object.keys(block_tree).length > 0) {
    const result = [];
    const stack = [block_tree];
    while (stack.length > 0) {
      const curr = stack.pop();
      const employee_id = curr.others.employee_id;

      if (employee_id) {
        result.push(employee_id);
      }

      if (curr.children) {
        stack.push(...curr.children);
      }
    }
    return result;
  } else {
    return null;
  }
};
